// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardStatusBreakdownRecordDto
 */
export interface ICardStatusBreakdownRecordDto {
    /**
     * 
     * @type {Date}
     * @memberof ICardStatusBreakdownRecordDto
     */
    date_of_birth?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    employment_status?: string;
    /**
     * 
     * @type {Date}
     * @memberof ICardStatusBreakdownRecordDto
     */
    employment_status_effective_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    card_first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    card_last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    card_type?: string;
    /**
     * 
     * @type {Date}
     * @memberof ICardStatusBreakdownRecordDto
     */
    card_created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardStatusBreakdownRecordDto
     */
    mailed_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICardStatusBreakdownRecordDto
     */
    activation_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    card_status?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    partner_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    distributor_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    employer_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    subsidiary_external_identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    partner_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    employer_employee_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusBreakdownRecordDto
     */
    id_source?: string;
    /**
     * 
     * @type {number}
     * @memberof ICardStatusBreakdownRecordDto
     */
    employee_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ICardStatusBreakdownRecordDto
     */
    custom_field_name_to_value?: { [key: string]: string; };
}

/**
 * Check if a given object implements the ICardStatusBreakdownRecordDto interface.
 */
export function instanceOfICardStatusBreakdownRecordDto(value: object): value is ICardStatusBreakdownRecordDto {
    return true;
}

export function ICardStatusBreakdownRecordDtoFromJSON(json: any): ICardStatusBreakdownRecordDto {
    return ICardStatusBreakdownRecordDtoFromJSONTyped(json, false);
}

export function ICardStatusBreakdownRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardStatusBreakdownRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'date_of_birth': json['date_of_birth'] == null ? undefined : (new Date(json['date_of_birth'])),
        'employment_status': json['employment_status'] == null ? undefined : json['employment_status'],
        'employment_status_effective_date': json['employment_status_effective_date'] == null ? undefined : (new Date(json['employment_status_effective_date'])),
        'card_first_name': json['card_first_name'] == null ? undefined : json['card_first_name'],
        'card_last_name': json['card_last_name'] == null ? undefined : json['card_last_name'],
        'card_type': json['card_type'] == null ? undefined : json['card_type'],
        'card_created': json['card_created'] == null ? undefined : (new Date(json['card_created'])),
        'mailed_date': json['mailed_date'] == null ? undefined : (new Date(json['mailed_date'])),
        'activation_date': json['activation_date'] == null ? undefined : (new Date(json['activation_date'])),
        'card_status': json['card_status'] == null ? undefined : json['card_status'],
        'partner_external_identifier': json['partner_external_identifier'] == null ? undefined : json['partner_external_identifier'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'distributor_external_identifier': json['distributor_external_identifier'] == null ? undefined : json['distributor_external_identifier'],
        'employer_external_identifier': json['employer_external_identifier'] == null ? undefined : json['employer_external_identifier'],
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'subsidiary_external_identifier': json['subsidiary_external_identifier'] == null ? undefined : json['subsidiary_external_identifier'],
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'partner_employee_id': json['partner_employee_id'] == null ? undefined : json['partner_employee_id'],
        'employer_employee_id': json['employer_employee_id'] == null ? undefined : json['employer_employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'id_source': json['id_source'] == null ? undefined : json['id_source'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'custom_field_name_to_value': json['custom_field_name_to_value'] == null ? undefined : json['custom_field_name_to_value'],
    };
}

export function ICardStatusBreakdownRecordDtoToJSON(json: any): ICardStatusBreakdownRecordDto {
    return ICardStatusBreakdownRecordDtoToJSONTyped(json, false);
}

export function ICardStatusBreakdownRecordDtoToJSONTyped(value?: ICardStatusBreakdownRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date_of_birth': value['date_of_birth'] == null ? undefined : ((value['date_of_birth']).toISOString().substring(0,10)),
        'employment_status': value['employment_status'],
        'employment_status_effective_date': value['employment_status_effective_date'] == null ? undefined : ((value['employment_status_effective_date']).toISOString().substring(0,10)),
        'card_first_name': value['card_first_name'],
        'card_last_name': value['card_last_name'],
        'card_type': value['card_type'],
        'card_created': value['card_created'] == null ? undefined : ((value['card_created']).toISOString().substring(0,10)),
        'mailed_date': value['mailed_date'] == null ? undefined : ((value['mailed_date']).toISOString().substring(0,10)),
        'activation_date': value['activation_date'] == null ? undefined : ((value['activation_date']).toISOString().substring(0,10)),
        'card_status': value['card_status'],
        'partner_external_identifier': value['partner_external_identifier'],
        'partner_name': value['partner_name'],
        'distributor_external_identifier': value['distributor_external_identifier'],
        'employer_external_identifier': value['employer_external_identifier'],
        'employer_name': value['employer_name'],
        'subsidiary_external_identifier': value['subsidiary_external_identifier'],
        'subsidiary_name': value['subsidiary_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'partner_employee_id': value['partner_employee_id'],
        'employer_employee_id': value['employer_employee_id'],
        'ssn': value['ssn'],
        'id_source': value['id_source'],
        'employee_id': value['employee_id'],
        'custom_field_name_to_value': value['custom_field_name_to_value'],
    };
}

